<template>
  <div class="consumptions">
    <div class="container">
        <filters-ts page="consumptions" :settings="settings" :select-devices="false" @get-ts-data="getTsData"></filters-ts>
      <div id="chart" class="row">
        <div v-if="getData" class="col-md-12">
          <ts-chart :key="getData" page="consumptions" :settings="settings" :get-data="getData"></ts-chart>
        </div>
      </div>
      <div class="row">
        <div v-if="getData" class="col-md-12">
          <datatable :key="getData" page="consumptions" :settings="settings" :get-data="getData"></datatable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FiltersTs from '@/components/Filters/TS.vue';
  import TsChart from '@/components/Filters/TSChart.vue';
  import Datatable from '@/components/Datatable.vue';
  
  export default {
    name: "consumptions",

    components: {FiltersTs, TsChart, Datatable},   
    
    data() {
      return {
        settings: {
          parametersAttributes: { //Obbligatorio
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control'},
            disabled: {value: false},
            options: {value: [
              {paramId: 264, description: "Energia Attiva Importata"}
            ]},
            idField: {value: 'paramId'},
            labelField: {value: 'description'},
            value: {value: null}
          },
          aggregationFrequencyAttributes: { //Obbligatorio se mode = CONS
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control'},
            options: {value: [
              {id: 'HOURLY', label: 'Oraria'},
              {id: 'DAILY', label: 'Giornaliera'},
              // {id: 'WEEKLY', label: 'Settimanale'},
              // {id: 'MONTHLY', label: 'Mensile'},
              // {id: 'YEARLY', label: 'Annuale'},
            ]},
            value: {value: null}
          },
          aggregationModeAttributes: { //Si se aggregationFrequencyAttributes specificato
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control'},
            disabled: {value: true},
            options: {value: [
              // {id: 'MIN', label: 'Minimo'},
              // {id: 'MAX', label: 'Massimo'},
              // {id: 'AVG', label: 'Media'},
              // {id: 'LAST', label: 'Ultimo del periodo'},
              // {id: 'SUM', label: 'Somma'},
              {id: 'CONS', label: 'Consumi'},
            ]},
            value: {value: null}
          },
          lowerboundAttributes: {
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control form-datepicker'},
            label: {value: 'Da'},
            placeholder: {value: 'Seleziona una data'},
            required: {value: false},
            dateFormat: {value: 'DD/MM/YYYY'},
            disabled: {value: false},
            value: {value: null}
          },
          upperboundAttributes: {
            columns: {value: 'col-lg-12'},
            classes: {value: 'form-control form-datepicker'},
            label: {value: 'A'},
            placeholder: {value: 'Seleziona una data'},
            required: {value: false},
            dateFormat: {value: 'DD/MM/YYYY'},
            disabled: {value: false},
            value: {value: null}
          }
        },
        getData: null
        }
    },

    methods: {
      getTsData() {
        this.getData = (((1+Math.random())*0x10000)|0).toString(16).substring(1);

        this.$scrollTo('#chart', {offset: -20});
      }
    }
  };
</script>
